<template>
  <div style="margin-right: 8px; margin-left: 8px">
    <!-- 搜索 -->
    <el-button
      :size="size ? size : 'small'"
      v-if="type == 'search'"
      type="primary"
      icon="el-icon-search"
      @click="emits"
      >{{ title ? title : $t("button.query") }}</el-button
    >
    <!-- 新增 -->
    <el-button
    :size="size ? size : 'small'"
      v-if="type == 'add'"
      type="primary"
      icon="el-icon-plus"
      @click="emits"
      >{{ title ? title : $t("button.add") }}</el-button
    >
    <!-- 保存 -->
    <el-button
    :size="size ? size : 'small'"
      v-if="type == 'preserve'"
      type="primary"
      icon="el-icon-edit-outline"
      @click="emits"
      >{{ title ? title :$t('button.preservation') }}</el-button
    >
    <!-- 清空 -->
    <el-button
    :size="size ? size : 'small'"
      v-if="type == 'remove'"
      icon="el-icon-takeaway-box"
      @click="emits"
      >{{ title ? title : $t('button.empty') }}</el-button
    >
    <!-- 删除 -->
    <el-button v-if="type == 'delete'" icon="el-icon-delete" :size="size ? size : 'small'" @click="emits">{{
      title ? title : $t("button.delete")
    }}</el-button>
    <!-- 重置 -->
    <el-button v-if="type == 'reset'" icon="el-icon-refresh" :size="size ? size : 'small'" @click="emits">{{
      title ? title : $t("button.reset")
    }}</el-button>

    <!-- 上一步 -->
    <el-button v-if="type == 'prev'" icon="el-icon-back" :size="size ? size : 'small'" @click="emits">{{
      title ? title :$t('button.prev')
    }}</el-button>
    <!-- 下一步 -->
    <el-button v-if="type == 'next'" type="primary" :size="size ? size : 'small'" @click="emits"
      >{{ title ? title : $t('button.next') }}<i class="el-icon-right"></i
    ></el-button>

    <!-- 其他 -->
    <el-button
    :size="size ? size : 'small'"
      :type="buttonType ? buttonType : ''"
      v-if="type == 'custom'"
      :icon="icon ? icon : ''"
      @click="emits"
      :disabled="disabled"
      >{{ title }}</el-button
    >

    <!-- 导入 -->
    <el-upload
      v-if="type == 'import'"
      class="upload-demo"
      :action="action"
      accept=".xls,.xlsx"
      :headers="headers"
      :file-list="fileList"
      :data="qiniuData"
      :before-upload="beforeupload"
      :limit="1"
      :on-success="
        (response, file, fileList) => uploadSuccess(response, file, fileList)
      "
    >
      <el-button type="primary" icon="el-icon-upload2" :size="size ? size : 'small'">{{
        title ? title : $t('button.import')
      }}</el-button>
    </el-upload>

    <!-- 导出 -->
    <el-button
    :size="size ? size : 'small'"
      v-if="type == 'export'"
      type="primary"
      icon="el-icon-download"
      @click="emits"
      >{{ title ? title :$t('button.export') }}</el-button
    >

    <!-- 编辑 -->
    <el-button v-if="type == 'textEdit'" type="text" @click="emits" :size="size ? size : 'small'">{{
      title ? title : $t('button.edit')
    }}</el-button>
    <!-- 查看 -->
    <el-button v-if="type == 'textSee'" type="text" @click="emits" :size="size ? size : 'small'">{{
      title ? title :$t('button.look')
    }}</el-button>
    <!-- 删除 -->
    <el-button v-if="type == 'textDelete'" type="text" @click="emits" :size="size ? size : 'small'">{{
      title ? title : $t('button.delete')
    }}</el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      qiniuData: {},
      domain: null,
      headers: {},
      action:''
      // fileList: [], // 导入文件列表
    };
  },
  props: ["title", "type", "buttonType", "icon",'size','fileList','disabled'], //type：按钮类型，title：按钮标题
  mounted() {
    if (this.type == "import") {
      this.getQiniuToken();
      this.headers = { Authorization: localStorage.getItem("token") };
    }
  },
  methods: {
    //获取七牛token
    getQiniuToken() {
      this.request.qiniuUploadToken().then((res) => {
        this.qiniuData.token = res.data.uptoken;
        this.domain = res.data.domain;
        this.action = res.data.upload;
      });
    },
    uploadSuccess(res) {
      this.emits(res);
    },
    //调用父节点方法
    emits(response) {
      if (this.type == "import") {
        this.$emit("click", this.domain + response.key);
      } else {
        this.$emit("click");
      }
    },
    beforeupload(file) {
      this.qiniuData.key =
        "" +
        new Date().getTime() +
        Math.round(Math.random() * 10000) +
        "." +
        file.name.split(".")[file.name.split(".").length - 1];
      return true;
    },
  },
};
</script>

<style scoped>
</style>